// Libraries
import React, { useState } from 'react';
import PropTypes from 'prop-types';

// Styles
import './cardWithTab.scss';

/**
 * CardWithTab Component
 *
 * @param {Object} children - React component
 * @param {string} customClass - React className
 * @param {Array} tabs - Array of Object
 * @param {Node} content - content render prop
 */

const CardWithTab = ({ customClass, data, title, tabs, content }) => {
    const [selectedTab, setSelectedTab] = useState(tabs[0].value);

    const handleTab = value => {
        setSelectedTab(value);
    };

    return (
        <div className={`card-withTab ${customClass}`}>
            <div className="card-header">
                <p className="title">{title}</p>
                <ul className="tab-list">
                    {tabs &&
                        tabs.map(item => (
                            <li
                                className={
                                    item.value === selectedTab && 'active'
                                }
                                onClick={() => handleTab(item.value)}
                            >
                                <span>{item.label}</span>
                            </li>
                        ))}
                </ul>
            </div>
            {tabs &&
                tabs.map(item => (
                    <>
                        {selectedTab === item.value && data ? (
                            <div className="card-content">
                                {content(data[item.value])}
                            </div>
                        ) : null}
                    </>
                ))}
        </div>
    );
};

CardWithTab.propTypes = {
    children: PropTypes.node.isRequired,
    customClass: PropTypes.string,
    successRateTab: PropTypes.array,
    title: PropTypes.string,
    tabs: PropTypes.array,
    content: PropTypes.node,
    data: PropTypes.object,
};

export default CardWithTab;
